import React from 'react';

// ---------------- CARD BUILDERS ----------------

const renderValueCard = (change: any): React.JSX.Element => {
  return (
    <div key={`${change.id}-value`} className="change-card">
      <div className="user-info">
        <img
          src={change.userAvatar}
          alt={change.user}
          className="avatar"
        />
        <div className="details">
          <span className="username">
            {change.user}
          </span>
          <p className="action">
            Changed data in
            {' '}
            <span className="metric-name">
              {change.metricName}
            </span>
            {' '}
            {change.month && (
              <>
                {change.month}
                {' '}
              </>
            )}
            from
            {' '}
            <b className="action__changed-val">
              {change.oldValue}
            </b>
            {' '}
            to
            {' '}
            <b className="action__changed-val">
              {change.newValue}
            </b>
          </p>
          <span className="timestamp">
            {change.updated}
          </span>
        </div>
      </div>
    </div>
  );
};

const renderCommentCard = (change: any): React.JSX.Element => (
  <div key={`${change.id}-comment`} className="change-card">
    <div className="user-info">
      <img
        src={change.userAvatar}
        alt={change.user}
        className="avatar"
      />
      <div className="details">
        <span className="username">
          {change.user}
        </span>
        <p className="action">
          Commented
          {' '}
          <span className="comment-text">
            &ldquo;
            {change.comment}
            &rdquo;
          </span>
          {' '}
          on
          {' '}
          <span className="metric-name">
            {change.metricName}
          </span>
          {' '}
          {change.month && (
            <>
              {change.month}
              {' '}
            </>
          )}
        </p>
        <span className="timestamp">
          {change.updated}
        </span>
      </div>
    </div>
  </div>
);

const buildRecentChangeCards = (
  changes: any[],
  expanded: boolean,
): React.JSX.Element[] => {
  // ================= EXPANDED - Show ALL cards =================
  if (expanded) {
    return changes.flatMap((change) => {
      const cards: React.JSX.Element[] = [];
      
      // Add value change card if values differ
      if (Number(change.oldValue) !== Number(change.newValue)) {
        cards.push(renderValueCard(change));
      }
      
      // Add comment card if comment exists
      if (change.comment) {
        cards.push(renderCommentCard(change));
      }
      
      return cards;
    });
  }

  // ================= COLLAPSED - Show only first 2 CARDS =================
  const cards: React.JSX.Element[] = [];

  // Loop through changes and build cards until we have 2 cards
  for (const change of changes) {
    if (cards.length >= 2) break;

    const hasValueChange = Number(change.oldValue) !== Number(change.newValue);
    const hasComment = !!change.comment;

    // Add value change card first (if exists and we have space)
    if (hasValueChange && cards.length < 2) {
      cards.push(renderValueCard(change));
    }

    // Add comment card (if exists and we still have space)
    if (hasComment && cards.length < 2) {
      cards.push(renderCommentCard(change));
    }
  }

  return cards;
};

export default buildRecentChangeCards;
